// ConfigPage.jsx

import React, { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import LoadingAnimation from './components/LoadingAnimation';
import WebLogoFind from './components/WebLogoFind';

const defaultConfig = {
  showAllMenu: true,
  showChaminMenu: true,
  showYaapchikMenu: true,
  showBreadMenu: true,
  showLiverMenu: true,
  showDrinksMenu: true,
  showKugelMenu: true,
  showCustomMenu: true,
  showStoreMessageTextbox: true,
  showNadlanFeature: true,
  showLogoFinder: true,
  showExcelExport: true,
  showMonit: false,
  siteName: "הצ'ולנטיה",
};

export default function ConfigPage({ user }) {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(defaultConfig);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    async function fetchConfig() {
      setLoading(true);
      try {
        const docRef = doc(db, 'config', 'global');
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          setConfig({ ...defaultConfig, ...snap.data() });
        } else {
          await setDoc(docRef, defaultConfig);
          setConfig(defaultConfig);
        }
      } catch (e) {
        setError("שגיאה בטעינת קונפיגורציה");
      }
      setLoading(false);
    }
    fetchConfig();
  }, []);

  async function handleSave() {
    setSaving(true);
    setError("");
    try {
      const docRef = doc(db, 'config', 'global');
      await setDoc(docRef, config, { merge: true });
      
      // שמירת שם האתר בנפרד
      if (config.siteName) {
        await setDoc(doc(db, 'settings', 'siteName'), { name: config.siteName }, { merge: true });
      }
    } catch (e) {
      setError("שגיאה בשמירה");
    }
    setSaving(false);
  }

  if (loading) return <LoadingAnimation message="טוען קונפיגורציה..." />;
  if (saving) return <LoadingAnimation message="שומר קונפיגורציה..." />;

  return (
    <div className="max-w-xl mx-auto bg-gray-800 text-white rounded-xl shadow-xl p-8 mt-10">
      <h2 className="text-2xl font-bold mb-6 text-amber-400">קונפיגורציה גלובלית</h2>
      
      {/* שדה שם האתר */}
      <div className="mb-6">
        <label className="block text-lg font-semibold mb-2">שם האתר</label>
        <input
          type="text"
          value={config.siteName || "הצ'ולנטיה"}
          onChange={e => setConfig(c => ({ ...c, siteName: e.target.value }))}
          className="w-full bg-gray-700 text-white px-4 py-2 rounded-lg border border-gray-600 focus:border-amber-500 focus:outline-none"
          placeholder="הכנס שם האתר"
        />
      </div>
      
      <div className="mb-6 flex items-center justify-between border-b border-gray-600 pb-4">
        <span className="text-lg font-bold">הצג את כל התפריט לכל המשתמשים</span>
        <input
          type="checkbox"
          checked={config.showAllMenu}
          onChange={e => setConfig(c => ({ ...c, showAllMenu: e.target.checked }))}
          className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500"
        />
      </div>
      <div className="mb-6 flex flex-col gap-4">
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג תפריט חמין</span>
          <input type="checkbox" checked={config.showChaminMenu} onChange={e => setConfig(c => ({ ...c, showChaminMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג תפריט יאפצ'ק</span>
          <input type="checkbox" checked={config.showYaapchikMenu} onChange={e => setConfig(c => ({ ...c, showYaapchikMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג תפריט לחמניות</span>
          <input type="checkbox" checked={config.showBreadMenu} onChange={e => setConfig(c => ({ ...c, showBreadMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג תפריט פטה כבד</span>
          <input type="checkbox" checked={config.showLiverMenu} onChange={e => setConfig(c => ({ ...c, showLiverMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג תפריט שתייה</span>
          <input type="checkbox" checked={config.showDrinksMenu} onChange={e => setConfig(c => ({ ...c, showDrinksMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג תפריט קוגל</span>
          <input type="checkbox" checked={config.showKugelMenu} onChange={e => setConfig(c => ({ ...c, showKugelMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג מוצר</span>
          <input type="checkbox" checked={config.showCustomMenu} onChange={e => setConfig(c => ({ ...c, showCustomMenu: e.target.checked }))} className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" />
        </label>
        <label className="flex items-center justify-between pt-4 border-t border-gray-600">
          <span className="text-lg">הצג תיבת הודעות לחנות</span>
          <input 
            type="checkbox" 
            checked={config.showStoreMessageTextbox} 
            onChange={e => setConfig(c => ({ ...c, showStoreMessageTextbox: e.target.checked }))} 
            className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" 
          />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הצג רכיב נדל"ן</span>
          <input 
            type="checkbox" 
            checked={config.showNadlanFeature} 
            onChange={e => setConfig(c => ({ ...c, showNadlanFeature: e.target.checked }))} 
            className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" 
          />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">הפעל חיפוש לוגו אוטומטי</span>
          <input 
            type="checkbox" 
            checked={config.showLogoFinder} 
            onChange={e => setConfig(c => ({ ...c, showLogoFinder: e.target.checked }))} 
            className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" 
          />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">מוצר יבוא מאקסל</span>
          <input 
            type="checkbox" 
            checked={config.showExcelExport} 
            onChange={e => setConfig(c => ({ ...c, showExcelExport: e.target.checked }))} 
            className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" 
          />
        </label>
        <label className="flex items-center justify-between">
          <span className="text-lg">מונית</span>
          <input 
            type="checkbox" 
            checked={config.showMonit} 
            onChange={e => setConfig(c => ({ ...c, showMonit: e.target.checked }))} 
            className="w-6 h-6 text-amber-500 bg-gray-700 border-gray-600 rounded focus:ring-amber-500" 
          />
        </label>
      </div>

      <button
        onClick={handleSave}
        disabled={saving}
        className="bg-amber-500 hover:bg-amber-600 text-black font-bold py-2 px-6 rounded-lg transition-colors duration-150"
      >
        {saving ? "שומר..." : "שמור"}
      </button>
      {error && <div className="text-red-400 mt-4">{error}</div>}
    </div>
  );
}
